import { useFetchDocumentLanguage } from './useFetchDocumentLanguage'
import { queryKeys as documentQueryKeys, type QueryDocumentByIdCacheData } from '../useQueryDocument'

const update = () => {
  const { update } = useFetchDocumentLanguage()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: update,
    onMutate: (variables) => {
      queryClient.cancelQueries({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      })
    },
    onError: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      })
    },
    onSuccess: (responseData, variables) => {
      queryClient.setQueriesData<QueryDocumentByIdCacheData>({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      }, (oldData) => {
        if (!oldData)
          return oldData

        return {
          ...oldData,
          data: {
            ...oldData.data,
            languages: responseData.data,
          },
        }
      }, {
        updatedAt: Date.now(),
      })
    },
  })
}

export const useMutationDocumentLanguage = ({
  update,
})
